import { Component, Input, OnInit } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';
import { Translation } from '../../providers/translation';

@Component({
  selector: 'form-errors',
  template: `
    <ul *ngIf="hasErrors()">
    	<li style="color: red" *ngFor="let error of listOfErrors()">{{ error | translate: param }}</li>
    </ul>`
})
export class FormErrorsComponent implements OnInit {
  @Input() private control: AbstractControlDirective | AbstractControl;
  public errors;
  public param;

  ngOnInit() {
    this.errors = {
      required: () => 'form.required',
      minlength: params => {
        this.param = { value: params.requiredLength };
        return 'form.minlength';
      },
      maxlength: params => {
        this.param = { value: params.requiredLength };
        return 'form.maxlength';
      },
      pattern: params => {
        this.param = { value: params.requiredPattern };
        return 'form.pattern';
      },
      forbiddenSpace: params => {
        this.param = { value: params.forbiddenSpace };
        return 'form.space';
      }
    };
  }

  hasErrors(): boolean {
    return this.control && this.control.errors && (this.control.dirty || this.control.touched);
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors).map(field =>
      this.getMessage(field, this.control.errors[field])
    );
  }

  private getMessage(type: string, params: any) {
    if (type in this.errors) {
      this.param = {};
      return this.errors[type](params);
    }
    return params.message;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/form_errors/form_errors.component.ts